import { FC } from 'react';
import type { RejectedWithoutPriceTileData } from 'state/quotes/dashboard/model';

import { PricingDate, ResultPanel, SolveModeLabel, TileLayout } from './components';
import { Rejections } from './components/rejections';
import type { TileContentProps } from './Tile.common';

export const RejectedWithoutPriceTile: FC<TileContentProps<RejectedWithoutPriceTileData>> = ({
  quoteId,
  data,
  header,
  subHeader,
  footer,
}) => {
  return (
    <TileLayout header={header} subHeader={subHeader} footer={footer}>
      <ResultPanel
        color="danger"
        solveModeLabel={<SolveModeLabel value={data.solveMode} size="small" />}
        statusPanel={
          <Rejections
            id={quoteId}
            errorMessages={data.errorMessages}
            shouldDisplayErrorDetails={data.shouldDisplayErrorDetails}
          />
        }
        subHeader={<PricingDate when={data.lastUpdated} />}
      />
    </TileLayout>
  );
};

RejectedWithoutPriceTile.displayName = 'RejectedWithoutPriceTile';
